document.addEventListener("DOMContentLoaded", function () {
  const accordion = document.querySelector(".panel-accordion");
  if (!accordion) return;

  const header = accordion.querySelector(".panel-accordion__header");

  header.addEventListener("click", function () {
    accordion.classList.toggle("active");
  });
});